import React, { forwardRef } from 'react';
import enGb from 'date-fns/locale/en-GB';
import DatePicker, { registerLocale } from 'react-datepicker';
import moment from 'moment';
import './week-picker.scss';

registerLocale('en-gb', enGb);
const WeekPicker = (props) => {
    let selectedDate = props?.defaultDate ? new Date(props.defaultDate) : null
    const handleCalendarOpen = () => {
        Array.from(document.getElementsByClassName('react-datepicker__week')).forEach(e => {
            if (!e.className.includes('weekpicker__week')) e.className += ' weekpicker__week'
        });
        Array.from(document.getElementsByClassName('react-datepicker__day')).forEach(e => {
            if (!e.className.includes('weekpicker__day')) e.className += ' weekpicker__day'
        });
    };
    const WeekInput = forwardRef(({ value, onClick }, ref) => {
        let selectedWeek = value !== '' ? 'Start: ' + moment(value).format('MM/DD/yyyy')
            + ' 07:00:00 MT — End: ' + moment(value).add(7, 'd').format('MM/DD/yyyy')
            + ' 07:00:00 MT' : null
        return (
            <button className='weekpicker-btn' onClick={onClick} ref={ref}>{selectedWeek}</button>
        )
    });
    const getMaxDate = () => {
        // Obtains previous week
        const maxDate = new Date(moment(new Date()).startOf('week').subtract(1, 'weeks')
            .startOf('week').add(7, 'd'))
        return maxDate
    }

    return (
        <DatePicker
            locale='en-gb'
            selected={selectedDate}
            onChange={(date) => {
                selectedDate = new Date(moment(date).startOf('week').add(1, 'd'));
                props.setSelectedWeek(new Date(moment(date).startOf('week').add(1, 'd')));
            }}
            dayClassName={(date) =>
                moment(date).isoWeek() === moment(selectedDate).isoWeek()
                    ? 'weekpicker__day--selected' : ''
            }
            minDate={new Date(props.minDate)}
            maxDate={getMaxDate()}
            onCalendarOpen={handleCalendarOpen}
            onMonthChange={handleCalendarOpen}
            customInput={<WeekInput />}
            showYearDropdown
        />
    );
}

export default WeekPicker